<div class="view-more">
  <button class="view-more__btn">VER MAIS</button>
</div>
